import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { useMatch, useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import Button from '@/components/atoms/Button'
import { useAppSelector } from '@/store/hooks'

export function Topbar() {
	const {
		matriculate: { classSelect },
	} = useAppSelector((state) => state)

	const isContentCourse = useMatch('/curso/:slug/:slug')
	const navigate = useNavigate()

	const [scrolling, setScrolling] = useState(isContentCourse ? true : false)

	useEffect(() => {
		if (!isContentCourse) {
			const handleScroll = () => {
				if (window.scrollY > 0) {
					setScrolling(true)
				} else {
					setScrolling(false)
				}
			}

			window.addEventListener('scroll', handleScroll)

			return () => {
				window.removeEventListener('scroll', handleScroll)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<>
			<header
				className={twMerge(
					'w-full sticky top-0 overflow-clip z-30 bg-banner-course transition-colors duration-200',
					classNames({
						'border-gray-100 shadow-sm dark:shadow-2xl': scrolling,
					})
				)}
			>
				<Container className='relative overflow-visible w-full !max-w-[1242px] xl:px-0 2xl:px-0 h-auto py-4 min-h-[81px] md:min-h-[91px] lg:min-h-[111px] flex items-center justify-between'>
					<div className='flex items-center gap-6 md:gap-8 lg:gap-12'>
						<div className='flex flex-col'>
							<Button
								className='w-full max-w-max h-auto border-solid bg-transparent hover:bg-transparent py-2 rounded-full md:px-4'
								onClick={() => navigate('/curso')}
							>
								<Icon
									name='arrow-left'
									width='20'
									height='20'
									className='text-[#000000]'
								/>
								<p className='ml-2 md:ml-3 text-zinc-50'>Voltar</p>
							</Button>
						</div>
						{classSelect?.name && (
							<div className='flex flex-col w-full md:max-w-[55%] 2lg:max-w-[840px] z-20'>
								<p className='text-sm md:text-base leading-6 font-semibold text-white uppercase'>
									Curso de
								</p>
								<p className='text-lg md:text-xl lg:text-2xl 2lg:text-4xl font-bold leading-none text-white'>
									{classSelect.name}
								</p>
							</div>
						)}
						<Icon
							name='banner-course'
							width='330px'
							height='100%'
							className='absolute hidden -mr-40 md:flex lg:w-[330px] opacity-20 md:opacity-70 2lg:opacity-100 right-0 top-0 bottom-0 z-10'
						/>
					</div>
				</Container>
			</header>
		</>
	)
}
